export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/Worker.cc8d957b.worker.js");
}
